export default __webpack_public_path__ + "static/media/reviewing.dd24e685.jpg";